import { useMutation, useQueryClient } from '@tanstack/react-query'
import { isGuid } from '@/lib/isGuid'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { QUERY_KEY_SETTINGS_ADMIN_PANEL } from '@/lib/api/constants'

type SendInvitationPayload = {
  login: string
  /** Panel admina bez wybranej firmy wysyła zaproszenie bez tego parametru. */
  companyId?: string
}

async function sendInvitation(payload: SendInvitationPayload) {
  if (payload.companyId && !isGuid(payload.companyId)) {
    throw new Error(`Invalid companyId for invitation: ${payload.companyId}`)
  }
  const url = payload.companyId
    ? `/config-api/user/sendInvitationEmail?companyId=${encodeURIComponent(payload.companyId)}`
    : '/config-api/user/sendInvitationEmail'
  const response = await axiosInstance.post(url, {
    login: payload.login,
  })
  return response.data
}

export function useMutationSendInvitation(companyId?: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (login: string) => sendInvitation({ login, companyId }),
    onSuccess: () => {
      // Optionally refetch users list
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SETTINGS_ADMIN_PANEL, 'users', companyId],
      })
    },
  })
}
